module.exports = __webpack_public_path__ + "img/Mask Group 2920@2x.3e6c6609.png";